import React from "react";
import PropTypes from "prop-types";
import {FaRegularIcon, FaSolidIcon} from "../../../components/FontAwesomeIcons";

export class CreateEventOptionsStep extends React.Component {
    constructor(props) {
        super(props);
        this.iconBoxStyle = {
            width: "42px",
            minWidth: "42px",
            height: "42px",
        };
    }

    handleAddLink = _ => {
        if (!this.props.eventData.externalLinksEnabled) {
            this.props.onCheckboxChange("externalLinksEnabled")({target: {checked: true}});
        }
        this.props.onLinksChange([
            ...this.props.eventData.externalLinks,
            {label: "", url: ""}
        ]);
    }

    handleRemoveLink = index => _ => {
        const links = this.props.eventData.externalLinks.slice();
        links.splice(index, 1);
        this.props.onLinksChange(links);
        if (!links.length) {
            this.props.onCheckboxChange("externalLinksEnabled")({target: {checked: false}});
        }
    }

    handleLinkChange = (index, field) => e => {
        const links = this.props.eventData.externalLinks.slice();
        links[index] = {
            ...links[index],
            [field]: e.target.value,
        };
        this.props.onLinksChange(links);
    }

    renderLink = (link, index) => (
        <div className={"border rounded p-3 mb-3 bg-white"} key={index}>
            <div className={"form-group mb-2"}>
                <label className={"font-weight-bold"}>Nome link</label>
                <input
                    type={"text"}
                    className={"form-control"}
                    value={link.label}
                    onChange={this.handleLinkChange(index, "label")}
                />
            </div>
            <div className={"form-group mb-2"}>
                <label className={"font-weight-bold"}>URL</label>
                <input
                    type={"url"}
                    className={"form-control"}
                    value={link.url}
                    onChange={this.handleLinkChange(index, "url")}
                />
            </div>
            <button
                type={"button"}
                className={"btn btn-sm btn-link text-danger p-0"}
                onClick={this.handleRemoveLink(index)}
            >
                <FaSolidIcon name={"trash"} className={"mr-1"}/>
                Rimuovi link
            </button>
        </div>
    )

    render() {
        return (
            <div className={"container py-3"}>
                <div className={"mb-3"}>
                    <h5 className={"font-weight-bold mb-1"}>Aggiungi qualcosa in più</h5>
                    <div className={"text-muted"}>Link utili e album foto della serata.</div>
                </div>

                <div className={"card border-0 shadow-sm mb-3"}>
                    <div className={"card-body"}>
                        <div className={"d-flex align-items-center mb-3"}>
                            <div
                                className={"rounded bg-light d-flex align-items-center justify-content-center text-magenta mr-3"}
                                style={this.iconBoxStyle}
                            >
                                <FaSolidIcon name={"link"}/>
                            </div>
                            <div>
                                <div className={"font-weight-bold"}>Link esterni</div>
                                <div className={"small text-muted"}>Aggiungi indicazioni, liste regalo o pagine utili.</div>
                            </div>
                        </div>
                        {this.props.eventData.externalLinks.map(this.renderLink)}
                        <button type={"button"} className={"btn btn-outline-primary btn-block"} onClick={this.handleAddLink}>
                            <FaSolidIcon name={"plus"} className={"mr-1"}/>
                            Aggiungi link
                        </button>
                    </div>
                </div>

                <div className={"card border-0 shadow-sm mb-3"}>
                    <div className={"card-body d-flex align-items-center"}>
                        <div
                            className={"rounded bg-light d-flex align-items-center justify-content-center text-magenta mr-3"}
                            style={this.iconBoxStyle}
                        >
                            <FaRegularIcon name={"images"}/>
                        </div>
                        <div className={"flex-grow-1"}>
                            <div className={"font-weight-bold"}>Album fotografico</div>
                            <div className={"small text-muted"}>Crea un album condiviso per raccogliere foto dell'evento.</div>
                        </div>
                        <div className={"custom-control custom-switch"}>
                            <input
                                type={"checkbox"}
                                className={"custom-control-input"}
                                id={"userEventPhotoAlbumEnabled"}
                                checked={this.props.eventData.photoAlbumEnabled}
                                onChange={this.props.onCheckboxChange("photoAlbumEnabled")}
                            />
                            <label className={"custom-control-label"} htmlFor={"userEventPhotoAlbumEnabled"}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CreateEventOptionsStep.propTypes = {
    eventData: PropTypes.object,
    onCheckboxChange: PropTypes.func,
    onLinksChange: PropTypes.func,
};
